export const Texts = {
    LOADING_CONTENT_DESCRIPTION: 'Carregando...',
    FAILED_DURING_LOAD_WHATSAPP_COMPONENT: 'Falhou ao carregar o componente de WhatsApp'
}
